import CheckboxInput from 'components/checkout/caap/CheckboxInput';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import PurchasePromos from 'components/checkout/caap/payment/paymentlist/PurchasePromos';
import { toUSD } from 'helpers/NumberFormats';
import { promoWrapper } from 'styles/components/checkout/caap/payment/paymentAsRadio.scss';

const PromoAsCheckbox = componentParams => {
  const {
    balance,
    cartType,
    eligibleBalances,
    usePromoBalance,
    onUsePromoBalanceClick
  } = componentParams;

  return (
    <div className={promoWrapper}>
      <CheckboxInput
        clearAfter={true}
        isNoBorder={false}
        isPromoCheckbox={true}
        isSolo={true}
        isChecked={usePromoBalance}
        onChange={onUsePromoBalanceClick}
        name="usePromoBalance">
        <Row>
          <RowSpan span="12">
            <strong>Use your {toUSD(balance)} gift card or promotional balance</strong>
          </RowSpan>
          <RowSpan span="12">
            <PurchasePromos
              cartType={cartType}
              eligibleBalances={eligibleBalances}
            />
          </RowSpan>
        </Row>
      </CheckboxInput>
    </div>
  );
};

export default PromoAsCheckbox;
